module.exports = __webpack_public_path__ + "static/media/baby-dragon.8ad1e0f4.png";